import { Injectable } from '@angular/core';
// import { EventEmitter } from 'events';
import { ApiService } from '../api/api.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Router } from '@angular/router';
import { config } from 'src/app/app.config';
import { _ } from 'underscore';
import { ServiceLogsService } from 'src/app/services/service-logs/service-logs.service';
import { ShareData } from 'src/app/app.share-data';
import { NavigateService } from '../navigate/navigate.service';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  listService: any[] = [];
  allListService: any[] = [];
  profile: any = {};
  mrkpRegisterStore: any = {};
  mrkpProductInfo: any = {};
  mrkpStoreInfo: any = {};

  nativePages = [{
    code: 'E0001',
    pages: 'FeedPage'
  }, {
    code: 'E0002',
    pages: 'NotificationPage'
  }, {
    code: 'E0003',
    pages: 'VoicePage'
  }, {
    code: 'E0004',
    pages: 'QrScanPage'
  }, {
    code: 'E0005',
    pages: 'ChatbotPage'
  }, {
    code: 'E0006',
    pages: 'MePage'
  }, {
    code: 'E0007',
    pages: 'ChatListPage'
  }];

  pages = [{
    code: 'A0001',
    pages: 'DigitalCardPage'
  }, {
    code: 'A0002',
    pages: 'DigitalContactPage'
  }, {
    code: 'A0003',
    pages: 'CheckinPage'
  }, {
    code: 'A0004',
    pages: 'NavigatePage'
  }, {
    code: 'A0005',
    // pages: 'EventListPage'
    pages: 'ActivityPage'
  }, {
    code: 'A0006',
    pages: 'NewsPage',
    notificationPage: 'NewsDetailPage'
  }, {
    code: 'A0007',
    pages: ''
  }, {
    code: 'A0008',
    pages: 'ShareWifiPage'
  }, {
    code: 'A0009',
    pages: 'NotificationPage'
  }, {
    code: 'A0010',
    pages: 'ChatListPage'
  }, {
    code: 'A0011',
    pages: 'FeedPage'
  }, {
    code: 'A0012',
    pages: 'FindFriendPage'
  }, {
    code: 'A0013',
    pages: 'CoreValuePage'
  }, {
    code: 'A0014',
    pages: 'ContactUsPage'
  }, {
    code: 'A0015',
    pages: 'DigitalBusinessCardPage'
  }, {
    code: 'A0016',
    pages: 'GetMoneyPage'
  }, {
    code: 'A0017',
    pages: 'RewardStorePage'
  }];

  device: any;

  constructor(
    private api: ApiService,
    private deviceService: DeviceDetectorService,
    private router: Router,
    private servLogs: ServiceLogsService,
    private navigate: NavigateService
  ) {
    this.device = this.deviceService.getDeviceInfo();
  }

  private loadPromise: Promise<any> | null = null;

  load(): Promise<any> {
    if (this.loadPromise) {
      return this.loadPromise;
    }

    this.loadPromise = new Promise((resolve, reject) => {
      this.api.getInitialData(true).subscribe(async (res: any) => {
        if (res.Code === 200) {
          const services = res.Results;
          this.allListService = [];
          services.forEach((service: any) => {
            this.allListService = this.allListService.concat(this.convertTreeToList(JSON.parse(JSON.stringify(service))));
          });

          if (services && services.length > 0) {
            services.forEach((item: any, index: number) => {
              const isService = this.pages.filter((p: any) => {
                return p.code === item.ServiceCode;
              });

              if (isService[0]) {
                item['pages'] = isService[0].pages;
              }

              if (index === services.length - 1) {
                this.badgeCounting();
                
                ShareData.allService = services;
                let SERVICE_LOGS: any = window.localStorage.getItem(this.servLogs.SERVICE_LOGS);

                if(SERVICE_LOGS){

                  SERVICE_LOGS = JSON.parse(SERVICE_LOGS);
                  let tempServiceLog;
                  let tempTimeStamp;
                  
                  for (let j = 0; j < SERVICE_LOGS.length; j++){
                    tempServiceLog = _.findWhere(services, { ServiceID: SERVICE_LOGS[j].ServiceID });
                    if (tempServiceLog) {
                      tempTimeStamp = SERVICE_LOGS[j].TimeStamp;
                      SERVICE_LOGS[j] = tempServiceLog;
                      SERVICE_LOGS[j].TimeStamp = tempTimeStamp;
                    }
                  }

                  window.localStorage.setItem(config.baseURL+'SERVICE_LOGS', JSON.stringify(SERVICE_LOGS));

                  let tempService1 = [], tempService2 = [];
                  let temp;
                  for(let i = 0; i < SERVICE_LOGS.length; i++){
                    temp = _.filter(services, function(n){ return n.ServiceID == SERVICE_LOGS[i].ServiceID });
                    if(temp){
                      tempService1.push(temp[0]);
                    }
                  }
                  // console.log(tempService1);
                  tempService2 = _.difference(services, tempService1);
                  // console.log(tempService2);
                  this.listService = SERVICE_LOGS.concat(tempService2);
                  // console.log(this.listService);
                  for (let i = 0; i < this.listService.length; i++) {
                    if(this.listService[i] && 'TimeStamp' in this.listService[i]) {
                      this.listService[i].TimeStamp = new Date(this.listService[i].TimeStamp);
                    }
                  }
                  this.listService = _.sortBy(this.listService, function(n){ return -new Date(n.TimeStamp).getTime()});
                } else {
                  this.listService = services;
                }
                resolve(res.Results);
              }
            });
          } else {
            resolve(res.Results);
          }
        } else {
          reject(false);
        }
      }, (err) => {
        console.log(err);
        if (err && err.error && (err.error.Code === 403 || err.error.Code === 401)) {
          // window.localStorage.removeItem(config.baseURL + '/token');
          // this.navigate.navigateMenu('signin', true);
        }
        this.loadPromise = null;
        reject(false);
      });
    });
    return this.loadPromise;
  }

  loadProfile(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.getMyProfile2().subscribe((res: any) => {
        this.profile = res.Results;
        if(!res.Results.Phone){
          this.navigate.navigateMenu('signin?reset=phone', true);
        }
        this.profile.FullNameAlt = this.profile.FullNameAlt || this.profile.FullName;
        resolve(this.profile);
      }, (err) => {
        console.log(err);
        if (err && err.error && err.error.Code === 403) {
          window.localStorage.removeItem(config.baseURL + '/token');
          this.navigate.navigateMenu('signin', true);
        }
        reject();
      });
    });
  }

  syncAppVersion(UserId: any) {
    const body = {
      UserId: UserId,
      AppVersion: config.version,
    };

    this.api.syncAppVersion(body).subscribe();
  }

  badgeCounting() {
    this.api.notificationCount().subscribe((res: any) => {
      if (res.Code === 200) {
        window.localStorage.setItem('badgeNotification', res.Results.Badge.toString());
      }
    });
  }

  convertTreeToList(root: any) {
    const stack = [], array = [], hashMap = {};

    if (root.IsEnable) {
      stack.push(root);
    }

    while (stack.length !== 0) {
      const node = stack.pop();
      if (node.ServiceList === null) {
        this.visitNode(node, hashMap, array);
      } else {
        for (let i = node.ServiceList.length - 1; i >= 0; i--) {
          stack.push(node.ServiceList[i]);
        }
        // node.ServiceList = null;
        array.push(node);
      }
    }

    return array;
  }

  visitNode(node: any, hashMap: any, array: any[]) {
    array.push(node);
  }

}
